import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmationService, ConfirmationConfig } from '@mtm/task-ui-angular';

import { NotificationService } from './notification.service';

@Injectable()
export class TaskUiConfirmationAdapter extends ConfirmationService {
  constructor(private notificationService: NotificationService) {
    super();
  }

  open(config: ConfirmationConfig): Observable<boolean> {
    return this.notificationService.open(config);
  }
}
